import { call, put, takeEvery, takeLeading } from "redux-saga/effects";
import { userHintsSlice } from "./userHintsReducer";
import { sendNotificationMessageAction } from "../Notifications/notificationsReducer";
import {
    NOTIFICATION_MESSAGE_HINT_EVENTS,
    NOTIFICATIONS_MESSAGE_TYPES
} from "../Notifications/notificationsConstants";
import { failurePut } from "../../app/failurePut";

export function* getUserHintsSaga() {
    try {
        yield put(
            sendNotificationMessageAction({
                type: NOTIFICATIONS_MESSAGE_TYPES.HINTS,
                params: {
                    event: NOTIFICATION_MESSAGE_HINT_EVENTS.GET_USER_HINTS,
                },
            }),
        );
    } catch (e) {
        yield call(failurePut, e, userHintsSlice.actions.loadUserHintsErrorAction);
    }
}

export function* addUserHintSaga({ payload: hint_name }: ReturnType<typeof userHintsSlice.actions.initAddUserHintAction>) {
    try {
        yield put(
            sendNotificationMessageAction({
                type: NOTIFICATIONS_MESSAGE_TYPES.HINTS,
                params: {
                    event: NOTIFICATION_MESSAGE_HINT_EVENTS.ADD_USER_HINT,
                    payload: { hint_name },
                },
            }),
        );
    } catch (e) {
        yield call(failurePut, e, userHintsSlice.actions.loadUserHintsErrorAction);
        yield put(userHintsSlice.actions.loadAddUserHintSuccess({ id: Date.now(), hint_name }))
    }
}

export function* userHintsSagas() {
    yield takeLeading(userHintsSlice.actions.initUserHintsAction, getUserHintsSaga)
    yield takeEvery(userHintsSlice.actions.initAddUserHintAction, addUserHintSaga)
}